import React, { useEffect, useState } from 'react'
import { CssBaseline, ThemeProvider, Theme, Stack } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'

import Env from '../../shared/config/envConfig'
import appConfig from '../../shared/config/appConfig'
import editConfig from '../../shared/config/editConfig'
import { getAppTheme } from '../../shared/config/getAppTheme'
import SnackbarComponent from '../../shared/components/MessageComponents/SnackbarComponent'
import { getPrefersDarkMode, getUser } from '../../store/settings/settings.selectors'
import { Route, Switch } from 'react-router'
import TableActionButtons from './TableActionButtons'

// Import CRUDE
import { CrudeConfiguration } from '@3m5/crude-frontend/dist/shared/types/configurationTypes'
import { useCrude, CrudeContext } from '@3m5/crude-frontend/dist/crudeHooks'
import { crudeRootReducer } from '@3m5/crude-frontend/dist/store/crudeRoot.reducer'

import Login from '../../shared/components/Login'
import { useHistory } from 'react-router-dom'
import { setUser } from '../../store/settings/settings.actions'
import HeaderComponent from './Header/HeaderComponent'
import Settings from './Settings'
import crudeLicense from '../../shared/config/crudeLicense'
import crudeTabConfig from '../../shared/config/crudeTabConfig'
import { createStore } from 'redux'
import { addCsrfHeaders, CSRF_HEADER, getCsrfToken } from '../../shared/config/csrf'

const App: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const store2 = createStore(
    crudeRootReducer,
  )

  const user = useSelector(getUser)
  const darkMode = useSelector(getPrefersDarkMode)

  const [logout, setLogout] = useState<boolean>(false)
  const [theme, setTheme] = useState<Theme>(getAppTheme(darkMode))
  const appName = 'abx_admin_area'

  useEffect(() => {
    const oldMode = localStorage.getItem('darkMode') === 'true'
    store2.getState().crudeStore.darkMode = darkMode
    if (oldMode !== darkMode) {
      localStorage.setItem('darkMode', darkMode ? 'true' : 'false')
      location.reload()
    }
  },
  [darkMode],
  )

  const basePath = Env.basePath
  const requestHeaders: HeadersInit = new Headers()
  requestHeaders.set('Accept', 'application/json')
  requestHeaders.set('Content-Type', 'application/json')
  addCsrfHeaders(requestHeaders)

  useEffect(() => {
    const restUrl = `${basePath}/api/session/user`
    fetch(restUrl,
      {
        method: 'GET',
        credentials: 'include',
        headers: requestHeaders,
      })
      .then(res => res.json())
      .then(json => {
        dispatch(setUser(json))
      })
      .catch(err => console.log(err))
  },
  [],
  )

  const _onLogout = () => {
    const restUrl = `${basePath}/api/session/logout`
    fetch(restUrl,
      {
        method: 'POST',
        credentials: 'include',
        headers: requestHeaders,
      })
      .then(() => dispatch(setUser(undefined)))
      .catch(err => console.log(err))
  }

  useEffect(() => {
    const oldMode = localStorage.getItem('darkMode') === 'true'
    setTheme(getAppTheme(darkMode))
    if (oldMode !== darkMode) {
      localStorage.setItem('darkMode', darkMode ? 'true' : 'false')
    }
  },
  [darkMode],
  )

  useEffect(() => {
    logout && _onLogout()
  }, [logout],
  )

  useEffect(() => {
    let pathname = `${appName}/Product`
    if (!user) {
      pathname = 'login'
    }
    history.push(`/${pathname}`)
  }, [history, user],
  )

  const crudeConfiguration: CrudeConfiguration = {
    theme: theme,
    path: `/${appName}`,
    api: {
      app: appName,
      restPath: `${Env.crudeRestBase}/api/crude/`,
      headers: [
        {
          name: CSRF_HEADER,
          getHeader: (): string => getCsrfToken(),
        },
      ],
    },
    appLayout: appConfig(),
    editLayout: editConfig(),
    crudeLicense: crudeLicense(),
    tabs: crudeTabConfig(),
  }

  window.addEventListener('CrudeLogout', (() => {
    setLogout(true)
    dispatch(setUser(undefined))
  }) as EventListener)

  const SettingsApp = () => (<Settings />)
  const crudeContext = useCrude({ appPageProps: crudeConfiguration, tableActionComponent: TableActionButtons })
  return (
    <>
      <CrudeContext.Provider value={crudeContext}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Stack spacing={2} sx={{ width: '100%', padding: '0 20px' }}>
            <div className='main'>
              {user &&
                <>
                  <HeaderComponent doLogout={_onLogout} />
                </>}
              <Switch>
                <Route exact path='/apps/settings' component={SettingsApp} />
                <Route exact path='/login' component={Login} />
                <Route path='/' component={crudeContext.Crude} />
              </Switch>
            </div>
            {TableActionButtons}
            <SnackbarComponent />
          </Stack>
        </ThemeProvider>
      </CrudeContext.Provider>
    </>
  )
}

export default App
